import type { FC } from 'react';
import React from 'react';

import type { IBrand, TBrandList } from './models';

export const BrandList: FC<TBrandList> = ({
    brands,
    columnsNumber,
    onClick,
    selectedBrand,
    styles,
}) => {
    let remainingBrandsNumber = brands.length;
    const columnsList: IBrand[][] = new Array(columnsNumber)
        .fill(null)
        .reduce((columns, _, index) => {
            if (remainingBrandsNumber === 0) {
                return columns;
            }
            const remainingColumnsNumber = columnsNumber - index;
            const isClearDivision = remainingBrandsNumber % remainingColumnsNumber === 0;
            let numberBrandsInColumn = remainingBrandsNumber / remainingColumnsNumber;

            if (!isClearDivision) {
                numberBrandsInColumn = Math.ceil(numberBrandsInColumn);
            }
            remainingBrandsNumber -= numberBrandsInColumn;

            const startIndex = columns.flat().length;
            const finishIndex = startIndex + numberBrandsInColumn;

            return [...columns, brands.slice(startIndex, finishIndex)];
        }, []);

    return (
        <section className={styles.brandList}>
            {columnsList.map(column => (
                <ul key={column[0].value} className={styles.column}>
                    {column.map(({ label, value }) => (
                        <li key={value} className={styles.item}>
                            <button
                                className={
                                    value === selectedBrand ? styles.buttonSelected : styles.button
                                }
                                onClick={() => onClick(value)}
                            >
                                {label}
                            </button>
                        </li>
                    ))}
                </ul>
            ))}
        </section>
    );
};
